import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "q1-2023-goals"
    }}>{`Q1 2023 Goals`}</h2>
    <ul>
      <li parentName="ul">{`Objective: Reduce TOIL`}
        <ul parentName="li">
          <li parentName="ul">{`KR: Migrate PostgreSQL out of Heroku and into the correct AWS account`}
            <ul parentName="li">
              <li parentName="ul">{`Why? Reduce cost and reduce risk of us maxing out the instance`}</li>
            </ul>
          </li>
          <li parentName="ul">{`KR: Consolidate infrastructure into the correct AWS accounts (specifically US)`}
            <ul parentName="li">
              <li parentName="ul">{`Why? This will reduce the toil and AWS expenses`}</li>
            </ul>
          </li>
        </ul>
      </li>
      <li parentName="ul">{`Objective: Support other teams and enable other teams to self-serve`}
        <ul parentName="li">
          <li parentName="ul">{`KR: Most of the pipeline team has written/contributed to their own alerting system`}
            <ul parentName="li">
              <li parentName="ul">{`Once the system is set up well, would be good to get the other teams doing this too`}</li>
              <li parentName="ul">{`Why? Enable the pipeline team to self-serve their issues`}</li>
            </ul>
          </li>
          <li parentName="ul">{`Metric to track: % of non-infra hero time supporting other teams  `}</li>
        </ul>
      </li>
      <li parentName="ul">{`Objective: Keep infra spend flat at $120k/month`}
        <ul parentName="li">
          <li parentName="ul">{`Such as `}<a parentName="li" {...{
              "href": "https://github.com/PostHog/posthog/issues/13153"
            }}>{`Guido’s list`}</a></li>
          <li parentName="ul"><em parentName="li">{`Will likely decrease cost first then increase with usage`}</em></li>
          <li parentName="ul">{`Why? Improving our gross profit margin`}</li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "roadmap"
    }}>{`Roadmap`}</h2>
    <h4 {...{
      "id": "3-year"
    }}>{`3-year`}</h4>
    <ul>
      <li parentName="ul">{`All infrastructure is managed as code`}</li>
      <li parentName="ul">{`Cloud is global`}</li>
      <li parentName="ul">{`Best in class security and privacy compliance`}</li>
      <li parentName="ul">{`Scale beyond 1 Trillion events / month`}</li>
      <li parentName="ul">{`Support non-k8s Deploys 🤖`}</li>
      <li parentName="ul">{`Painless developer/contributor experience`}</li>
    </ul>
    <h4 {...{
      "id": "6-month"
    }}>{`6 month`}</h4>
    <ul>
      <li parentName="ul">{`No Heroku`}</li>
      <li parentName="ul">{`5 Billion / month events`}</li>
      <li parentName="ul">{`SOC 2 Ready`}</li>
      <li parentName="ul">{`All infra is managed as code on prod / staging + EU Ready 🎈`}</li>
      <li parentName="ul">{`Rock solid, reliable infrastructure with regular production load testing to inform scaling plans`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      